import React, { Component } from "react";
import Swiper from "screens/home/components/swiper";
import TextItemCombo from "./components/textitemcombo.js";
import Link from "../../components/link";
import "./why.css";

import Image1 from "./assets/image1.png";
import Image2 from "./assets/image2.png";
import Image3 from "./assets/image3.png";

const OFFSET_FACTOR_DK = 88.6458332667;
const OFFSET_FACTOR_MB = 94.20138;

const VIEWPORT_WIDTH_DK = 1366;
const VIEWPORT_WIDTH_MB = 414;

const SECTIONS = [
  {
    alt:
      "Person doing a side plank pose, with the that is up holding a weight, and the hand that is down grabbing a weight pressed to the floor.",
    orientation: "standard",
    header: "Access the most exclusive boutique fitness & wellness brands",
    description:
      "Our 30+ wellness partners were handpicked for their excellence, proven methodologies, and expert practitioners across Yoga, HIIT, Pilates, Strength Training, Meditation, Acupressure, Hormone Regulation, and more. With new videos added monthly - never get bored!",
    imgSrc: Image1,
    imgClassName: "js-home-why-img-1",
    textContainerClassName: "js-home-why-text-container-1",
    headerClassName: "js-home-why-header js-home-why-header-1",
    textClassName: "js-home-why-text",
    containerClassName: "js-home-why-combo-container",
  },
  {
    alt: "Person jumping up in the middle of an exercise.",
    orientation: "reverse",
    header: "Sweat, breathe and recover your way, on your watch.",
    description:
      "Whether you want a 10-minute morning meditation or a 1-month fitness & recovery program tailored to your goals - JETSWEAT adapts to your preferences, tracks your progress, and keeps you motivated along the way.",
    imgSrc: Image2,
    imgClassName: "js-home-why-img-2",
    textContainerClassName: "js-home-why-text-container-2",
    headerClassName: "js-home-why-header",
    textClassName: "js-home-why-text",
    containerClassName: "js-home-why-combo-container",
  },
  {
    alt:
      "Person doing yoga while watching a class on their tablet on the floor.",
    orientation: "standard",
    header: "Stream unlimited video classes & sessions from any device.",
    description:
      "Your all-access JETSWEAT membership lets you stream exclusive workout classes and wellness sessions on-demand at home or on the go through or mobile app, website, or your TV via Chromecast or HDMI.",
    imgSrc: Image3,
    textContainerClassName: "js-home-why-text-container-3",
    imgClassName: "js-home-why-img-3",
    headerClassName: "js-home-why-header",
    textClassName: "js-home-why-text",
    containerClassName: "js-home-why-combo-container",
  },
];

export default class Why extends Component {
  render() {
    return (
      <div className="js-home-why-container d-flex flex-column align-items-center">
        <p className="h2 js-raleway js-font-40 js-font-30-mb js-font-semibold js-font-black js-home-why-title">
          Why join JETSWEAT?
        </p>
        <Swiper
          swiperDesktop={false}
          dotsClassName=""
          offsetDivider="10"
          containerClassName="js-home-why-swiper d-flex flex-md-column align-items-center"
          viewport_width_dk={VIEWPORT_WIDTH_DK}
          viewport_width_mb={VIEWPORT_WIDTH_MB}
          offset_factor_dk={OFFSET_FACTOR_DK}
          offset_factor_mb={OFFSET_FACTOR_MB}
          list={SECTIONS}
        >
          {SECTIONS.map((item, index) => {
            const {
              alt,
              header,
              description,
              imgSrc,
              imgClassName,
              textContainerClassName,
              headerClassName,
              textClassName,
              containerClassName,
              orientation,
            } = item;
            return (
              <TextItemCombo
                alt={alt}
                header={header}
                description={description}
                imgSrc={imgSrc}
                imgClassName={imgClassName}
                textContainerClassName={textContainerClassName}
                headerClassName={headerClassName}
                textClassName={textClassName}
                orientation={orientation}
                containerClassName={containerClassName}
                key={Math.random().toString(36).substring(2, 15)}
              />
            );
          })}
        </Swiper>
        <p className="h2 js-text-align-center js-font-40 js-font-25-mb js-font-semibold js-raleway js-font-000000 js-home-why-cta-description">
          Do it all for $19.99/mo - just half the cost of a single class or session at our studios!
        </p>
        <Link
          className="js-home-hero-cta-button-link"
          label="Start your free trial"
          color="light-green"
          href="/signup"
        />
      </div>
    );
  }
}
